import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class IamvideoService {

  constructor(private http: HttpClient) { }

  public uploadImage(data: any): Observable<any> {
    const url = environment.apiURL + `api/render`;
    const headers = new HttpHeaders().set('Content-Type', 'application/json').set('x-api-key', '7Z9j4YKp7lwQJSqP8j0g7RXeMZd6DMij0GupFVDH').set('Accept', 'application/json');
      
    return this.http.post(url, data, { headers });
  }

  getVideo(renderId: any, userId: any, uploadType: any): Observable<any> {
    let params;

    if (uploadType === 'final') {
      params = new HttpParams().set('renderId', renderId).set('update', 'true').set('userId', userId);
    } else {
      params = new HttpParams().set('renderId', renderId).set('update', 'false').set('userId', userId);
    }

    const headers = new HttpHeaders().set('Content-Type', 'application/json').set('x-api-key', '7Z9j4YKp7lwQJSqP8j0g7RXeMZd6DMij0GupFVDH');
    const url = environment.apiURL + `api/render/assets`;
    return this.http.get(url, { params, headers, responseType: 'text' });
  }

  upload(file: File): any {
    return this.getUploadURL(file.name, file.type)
      .toPromise()
      .then((uploadURL) => {
        console.log('upload url: ', uploadURL);
        // uploading content to S3
        return this.http.put(uploadURL.replace(/"/g, ''), file).toPromise()
          .then(() => {
            console.log('file uploaded successfully!');
            return this.getContentURL(file.name).toPromise().then(url => {
              console.log(url);
              // returning S3 content pre-signed URL
              return url.replace(/"/g, '');
            });
          }).catch(console.error);
      })
      .catch(console.error);
  }

  private getUploadURL(fileName: string, contentType: string): Observable<string> {
    return this.http.get(environment.apiURL + 'api/generate-upload-url', {
      params: { fileName, contentType },
      responseType: 'text'
    });
  }

  private getContentURL(fileName: string): Observable<string> {
    return this.http.get(environment.apiURL + 'api/generate-content-url', {
      params: { fileName },
      responseType: 'text'
    });
  }

  postIamVideo(data: any, id: any): Observable<any> {
    const url = environment.apiURL + `api/account/${id}/setup/4`;

    const formData = new FormData();

    formData.append('isIamVideoTool', 'false');
    formData.append('vid', data);
    formData.append('update', 'true');

    const headers = new HttpHeaders({
      'Access-Control-Allow-Origin': '*',
      'Accept': '*/*'
    });

    return this.http.post(url, formData, { headers });
  }

  getShowcases(): Observable<any> {
    const url = environment.apiURL + `cinejoy/api/showcases`;
    return this.http.get(url);
  }
   probeVideo(url): Observable<any> {

     url = environment.apiURL +  `https://api.shotstack.io/dev/probe/'`+url;
     const headers = new HttpHeaders({
      'Access-Control-Allow-Origin': '*',
      'Accept': '*/*'
    });
            return this.http.post(url,{ headers });




}
}
